import React, { useState } from "react";
import LoginComponent from "../../components/auth/LoginComponent";
import AuthService from "../../../services/authService";

export default () => {
  const urlParams = new URLSearchParams(window.location.search);
  const redUrl = urlParams.get("redUrl") || "/";

  const [state, setState] = useState({
    authState: {},
  });

  const loginWithPassword = async (email, password) => {
    setState({
      ...state,
      authState: {
        loading: true,
      },
    });
    const response = await AuthService.loginWithPassword(email, password);
    if (response.error) {
      setState({
        ...state,
        authState: {
          ...response,
          loading: false,
          error: true,
        },
      });
    } else {
      window.location.assign(redUrl);
    }
  };

  return (
    <LoginComponent
      authState={state.authState}
      loginWithPassword={loginWithPassword}
      redUrl={redUrl}
    />
  );
};
